//@flow
import React from 'react';
import Head from 'next/head';
import { Client } from '../prismic-configuration';
import { RichText } from 'prismic-reactjs';
import { PrismicFundraisingDoc } from '../types/prismic';
import { PageWrapper } from '../components/base';
import styles from '../styles/pages/fundraising.module.scss';

type Props = {
  doc: PrismicFundraisingDoc;
};

const FundraisingPage = ({ doc }: Props) => {
  const {
    page_title,
    header,
    header_image,
    subheader,
    disclaimer,
    donorbox_url,
  } = doc.data;

  return (
    <PageWrapper title={page_title}>
      <Head>
        <script
          src="https://donorbox.org/widget.js"
          // @ts-ignore
          paypalexpress="false"
        />
      </Head>
      <section className="section-first full-width fundraising-page">
        <section
          className={`inner-width inner-width-padding center text-center ${styles.donorHolder} ${styles.donorHeader}`}
        >
          <img
            className={styles.headerImg}
            src={header_image.url}
            alt={header_image.alt}
          />
          <h1 className="sr">{page_title}</h1>
          <h3>{header}</h3>
          <RichText render={subheader} />
          <p className={styles.signature}>
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path d="m93.9 79.7c2.1-1.9 3.5-1.3 4 1.6.3 2.7 0 5.3.3 7.8.3 7.5.3 15 .5 22.5 0 1.3.8 2.4 1.1 3.7.3.5.5 1.1 1.1 1.1.3 0 1.1-.5 1.1-1.1 1.1-2.7 2.1-5.3 3.2-8 1.1-2.9 1.9-5.6 2.9-8.6.3-.5.5-1.3.8-1.6.8-.5 1.9-1.3 2.4-1.1.8.3 1.6 1.3 1.6 2.1.3 3.5 0 7 0 10.4 0 .8.3 1.6.3 2.4h.5c.5-.5.8-1.1 1.1-1.6 1.3-2.9 2.7-5.6 4-8.6.5-1.1 1.1-2.1 2.1-3.2.5-.5 1.9-1.1 2.4-.8.8.3 1.3 1.3 1.6 2.1.3 1.6.3 3.5.8 5.3 0 .5.5 1.3 1.1 2.4.8-1.6 1.6-2.7 2.1-4 1.1-2.7 1.9-5.6 2.7-8.6.3-.8.5-1.6.8-2.4.5-1.1 2.1-1.1 2.4.3.3.8.5 1.9.5 2.7.3 4.3.5 8.8.8 13.1 0 .5.3.8.3 1.6.8-1.9 1.6-3.2 2.4-4.5 2.1-3.7 5.6-5.9 9.9-6.2 1.6-.3 3.2-.5 4.5-1.9 1.6-1.3 3.2-2.7 5.1-4 .5-.5 1.9-.8 2.4-.5s1.1 1.3 1.1 2.1v14.2c0 .8 0 1.6.3 2.4.5-2.1 1.3-4.5 1.9-6.7.3-1.1.8-1.9 1.3-2.7 2.4-3.7 5.3-6.2 10.2-5.9 2.1 0 4.3-.3 6.4-.5 1.3 0 1.6.8 1.9 1.9v4.8c0 .8.3 2.4.8 2.7 1.3.3 2.9.5 3.7 0 3.2-1.9 5.1-4.8 6.4-8 0-.3 0-.8.3-.8.5-.3 1.3-.5 1.9-.8 0 .5.3 1.3 0 1.9-1.9 2.7-3.7 5.3-5.6 8.3-1.9 2.7-5.9 3.5-8.6 1.3-.8-.5-1.1-1.9-1.3-2.7-.3-.5 0-1.3-.5-2.1-.5 1.1-1.1 2.1-1.9 2.9-.5.8-1.1 1.6-1.9 1.9s-2.1.5-2.7 0c-.5-.3-1.1-1.9-.8-2.4.8-1.9 1.9-3.7 2.7-5.6-4.3-.8-8.3 1.3-9.9 6.2-1.1 2.7-1.6 5.6-2.1 8.6-.3 1.3-.5 2.4-2.1 2.4s-2.1-1.3-2.4-2.4c-.3-1.3-.5-2.9-.5-4.5 0-4 0-7.8 0-11.8 0-.5 0-1.1 0-1.9-2.1 1.6-3.7 2.9-5.6 4.3-.3.3-.3 1.1-.5 1.3-.8 1.9-1.3 4-2.1 5.9-.3.5-.8 1.1-1.6 1.6-1.3.8-2.9 0-2.7-1.3.3-1.9.8-3.7 1.1-5.6-1.9 0-3.7.8-5.1 2.1-1.6 1.9-2.7 4-3.7 5.9-.5 1.1-.8 2.1-1.6 3.2-.5.5-1.3 1.1-1.9 1.1s-1.1-1.1-1.3-1.6c-.5-3.7-.8-7.5-1.1-11.2 0-.8 0-1.9-.3-2.7-.3.8-.5 1.3-.8 2.1-1.1 2.1-1.6 4.5-2.9 6.4-1.1 2.9-3.5 2.9-4.5.5-.8-1.3-1.1-2.9-1.3-4.3-.3-.8 0-1.9 0-2.7-.3 0-.5-.3-.5-.3-1.3 2.7-2.7 5.1-4 7.8-.8 1.3-1.3 2.9-1.9 4.3-.8 1.3-1.9 2.1-3.5 1.9-1.6-.3-2.1-1.6-2.1-2.9 0-2.4-.3-4.8-.3-7.2 0-1.3 0-2.4-.3-3.7-2.7 4-3.7 8.3-5.1 12.8-.5 1.9-1.3 3.5-2.1 5.1-1.3 2.1-4 1.9-5.1-.3-.5-1.3-1.1-2.9-1.1-4.5-.3-5.3-.3-11-.5-16.3-.3-4.5-.3-8.8-.5-13.6-1.6 1.9-1.3 3.7-1.1 5.3.3 2.9.5 5.9.5 8.8 0 .5-.8 1.3-1.1 1.9-.3-.5-1.1-1.1-1.1-1.9-.3-1.9 0-3.5-.5-5.3-.8 3.7-1.6 7.8-2.7 11.5-2.4 10.4-4.8 20.6-7.5 31-.3 1.1-.8 2.4-1.6 3.2s-1.9 1.3-2.9 1.3c-1.3 0-2.4-1.1-2.7-2.4-.5-2.9-1.3-5.9-1.3-8.8-.8-15.5-.3-30.8 1.9-46.3.5-4.3 1.6-8.6 2.4-12.8.3-1.9 1.3-3.5 2.4-5.1 2.7-3.5 8.3-2.7 9.6 1.6 1 4.8 2.1 9.6 3.2 14.7zm-19.3 33.4v13.9c0 2.9.5 5.9 2.7 8.3 1.1 1.3 1.9 1.3 2.7-.3 1.6-2.9 3.5-6.2 4.3-9.4 2.7-10.2 4.8-20.3 7.2-30.5 1.6-7.2 2.7-14.4.8-21.7-.8-2.9-1.3-6.2-3.7-8.3s-4.3-1.9-6.2.5c-2.9 4-4.3 8.6-5.1 13.4-2.4 11.4-3 22.6-2.7 34.1z" />
                <path d="m31.8 95.5c-1.6-2.7-2.9-4.8-4.3-7.2-.3-.5.3-1.3.3-2.1.5.5 1.3.8 1.6 1.3 1.1 2.1 2.1 4.3 3.5 6.7 2.1-2.4 4-4.8 5.9-7 .5-.8 1.1-1.3 1.9-1.9.5-.3 1.1-.3 1.6-.5 0 .5.3 1.3 0 1.6-1.6 1.9-3.2 3.7-4.8 5.3-1.1 1.1-2.1 1.9-3.5 3.2 1.6 1.3 3.2 2.7 4.8 4s3.2 2.4 4.8 3.5c-3.7-1.6-7.2-3.7-10.7-6.7-2.1 2.1-4 4-5.9 6.2-1.3 1.3-2.4 2.7-3.7 3.7-.3.3-1.1.3-1.6.3 0-.5 0-1.3.5-1.9 3.2-2.4 6.7-5.6 9.6-8.5z" />
                <path d="m17.9 89.6c1.3.3 2.9.5 4.5.8v.8c-1.6 0-3.5 0-5.1 0-1.3 0-2.4.3-3.5 1.3-1.9 1.6-3.7 3.2-5.6 4.5-.5.3-1.3.3-1.9.3.3-.5.3-1.3.8-1.6 1.9-1.6 3.7-3.2 5.6-4.8-1.1-.5-2.1-1.1-2.9-1.6-.5-.5-1.3-1.3-1.6-2.1-.3-.5.3-1.3.5-1.9.5.3 1.3.5 1.6 1.1 1.6 2.4 4.5 2.9 6.4.8 1.3-1.3 2.4-2.7 3.7-4 .3-.3.8-.3 1.6-.5 0 .5.3 1.3 0 1.9-1.1 1.5-2.5 3.1-4.1 5z" />
              </g>
            </svg>
          </p>
          <p>Aurora James, Fifteen Percent Pledge Founder</p>
          <div className={styles.donorbox}>
            <iframe
              // @ts-ignore
              allowpaymentrequest="allowpaymentrequest"
              name="donorbox"
              scrolling="no"
              seamless={true}
              src={donorbox_url}
              style={{
                width: '100%',
                maxWidth: '100%',
                minWidth: '250px',
                maxHeight: 'none !important',
              }}
              width="100%"
              height="900px"
              frameBorder="0"
            />
          </div>
          <div className={styles.disclaimer}>
            <RichText render={disclaimer} />
          </div>
        </section>
      </section>
    </PageWrapper>
  );
};

export async function getServerSideProps() {
  const client = Client();
  const doc = await client.getByUID('fundraising', 'fundraising', {});

  return {
    props: {
      doc,
    },
  };
}

export default FundraisingPage;
